import React from 'react';

const CustomEventLeaderboardPositionColumn = ({ playerPosition }) => {
    const position = (playerPosition && playerPosition.displayValue) || '-';

    return (
        <div className={'custom-event-leaderboard__position'}>
            {
                <div className={'live-player-hero__score score-cell score-cell--total-under score-cell--has-border '}>
                    {position}
                </div>
            }
        </div>
    );
};

export default CustomEventLeaderboardPositionColumn;
